function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 61 32 C 61 15.9875 48.0125 3 32 3 C 15.9875 3 3 15.9875 3 32 C 3 48.0125 15.9875 61 32 61 C 48.0125 61 61 48.0125 61 32 Z M 61 32 ",
    transform: "matrix(0.3125,0,0,0.3125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,49.803922%,0%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,49.803922%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12.996505 30.127423 L 51.003495 30.127423 C 51.551502 30.127423 52.002283 30.578204 52.002283 31.126212 L 52.002283 33.123788 C 52.002283 33.671796 51.551502 34.122577 51.003495 34.122577 L 12.996505 34.122577 C 12.448498 34.122577 11.997717 33.671796 11.997717 33.123788 L 11.997717 31.126212 C 11.997717 30.578204 12.448498 30.127423 12.996505 30.127423 Z M 12.996505 30.127423 ",
    transform: "matrix(0.220971,0.220971,-0.220971,0.220971,10.027621,-4.130694)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,49.803922%,0%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,49.803922%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12.135117 31.138753 C 12.135117 30.590745 12.594736 30.131126 13.133905 30.139965 L 51.140895 30.139965 C 51.680064 30.131126 52.139683 30.590745 52.139683 31.138753 L 52.139683 33.13633 C 52.139683 33.684338 51.680064 34.143957 51.140895 34.135118 L 13.133905 34.135118 C 12.594736 34.143957 12.135117 33.684338 12.135117 33.13633 Z M 12.135117 31.138753 ",
    transform: "matrix(0.220971,-0.220971,0.220971,0.220971,-4.159921,10.042938)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.065a964169ed8ef9759dced2f137c5b6.svg";
export { ForwardRef as ReactComponent };